import axios from 'axios';

// 全局超时时间
axios.defaults.timeout = 60000 * 10;

// 后端业务实例
const backServer = axios.create();

//backServer.defaults.baseURL = 'http://test-xmp-api.xmp.ai';
backServer.defaults.baseURL = '//xmp-api.mobvista.com';

backServer.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export const pushReport = (params) => {
  return backServer.post('/sys/company/push-lead', params);
};
